import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { Flex } from '../../components';

export const IconTile = ({ title, subtitle, icon, onClick = (f) => f }) => (
  <Flex.V
    sx={{
      justifyContent: 'center',
      alignItems: 'center',
      border: '1px solid #DDD',
      borderRadius: '4px',
      padding: '40px',
      gap: '20px',
      width: '400px',
      background: '#FFF',
      color: '#000',
      cursor: 'pointer',
      '&:hover': {
        borderColor: '#0D6DFF',
        color: '#0D6DFF',
      },
    }}
    onClick={onClick}
  >
    {icon}

    {title && (
      <Typography variant="h2" sx={{ color: 'inherit' }}>
        {title}
      </Typography>
    )}

    {subtitle && (
      <Typography variant="body1" sx={{ color: '#181d1f', fontSize: '14px' }}>
        {subtitle}
      </Typography>
    )}
  </Flex.V>
);

IconTile.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.any,
  onClick: PropTypes.func,
};
